import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { ParapheurTabs, type TabKey } from './ParapheurTabs';
import { CircuitListRow } from './CircuitListRow';
import { MissingSignatureBanner } from './MissingSignatureBanner';
import { parapheurCircuitPath } from '../../services/signature/parapheurRoutes';
import { mesEnvoisInbox, toSignInbox } from '../../services/signature/circuitRevision';
import {
  useMyPendingSteps,
  useMySentCircuits,
} from '../../hooks/queries/useSignatureCircuits';

export function ParapheurPage() {
  const [tab, setTab] = useState<TabKey>('to_sign');
  const navigate = useNavigate();
  const openCircuit = (id: string) => navigate(parapheurCircuitPath(id));

  const pending = useMyPendingSteps();
  const sent = useMySentCircuits();

  const toSign = toSignInbox(pending.data ?? []);
  const mesEnvois = mesEnvoisInbox(sent.data ?? []);

  const counts: Record<TabKey, number> = {
    to_sign: toSign.length,
    mes_envois: mesEnvois.length,
  };

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="main-container-gdm !pb-0 flex-shrink-0">
        <MissingSignatureBanner />
        <ParapheurTabs active={tab} onChange={setTab} counts={counts} />
      </div>

      <div className="flex-1 min-h-0 overflow-auto">
        <div className="main-container-gdm !pt-4">
          <div className="space-y-2">
            {tab === 'to_sign' && (pending.isLoading ? <Spinner /> : (
              toSign.length ? (
                toSign.map((s) => s.circuit && (
                  <CircuitListRow key={s.id} circuit={s.circuit} myStep={s} onClick={() => openCircuit(s.circuit!.id)} />
                ))
              ) : <Empty label="Aucun document à signer." />
            ))}
            {tab === 'mes_envois' && (sent.isLoading ? <Spinner /> : (
              mesEnvois.length ? (
                mesEnvois.map((c) => <CircuitListRow key={c.id} circuit={c} onClick={() => openCircuit(c.id)} />)
              ) : <Empty label="Aucune demande envoyée." />
            ))}
          </div>
        </div>
      </div>

    </div>
  );
}

function Spinner() {
  return <div className="flex items-center justify-center py-16 text-cime-text-muted"><Loader2 className="w-5 h-5 animate-spin" /></div>;
}
function Empty({ label }: { label: string }) {
  return <p className="text-sm text-cime-text-muted italic text-center py-12">{label}</p>;
}
